import superService from "./superService";
import O1HD, {modules, services} from "../gameEngine";
import gameConfig from "../configs/gameConfig";
import data_control from "../libs/data_control";
import { AqLoginMsg, AqUserLoginBody, AqUserLoginRes, Platform } from "../modules/httpContent/gameHttpContent";
import TtApi from "./miniGameContent/tt/ttApi";

interface WEB_USER_INFO {
    m_devilCurrLevel: number,
    m_coins: number,
    m_unlockStamp: number,
    m_synthesisEquipmentList: string[],
}

export enum MEMBERTYPE {
    //钻石
    DIAMOND,
    //王者
    KING
}

export enum BARDGEANITYPE {
    //钻石待机
    DIAMONDSTAND = "DiamondStand",
    //钻石打开
    DIAMONDOPEN = "DiamondArise",
    //王者待机
    KINGSTAND = "KingStand",
    //王者打开
    KINGOPEN = "Switch",
}

export default class userService extends superService {

    protected className: string = '用户服务';

    //观看广告恢复体力
    private m_constAddOncePower: number;
    //恢复体力 单位 : 秒(s)
    private m_constResetPowerTime: number;
    //恢复体力 参数
    private m_constResetPowerValue: number;
    //
    private m_constAddOnceCoins: number;
    //钻石
    private m_constAddOnceDiamonds: number;
    //最大体力
    private m_powerMax: number;
    //体力
    private m_power: number;
    private m_normalPower: number;
    private m_normalDiamond: number;
    //金币
    private m_coins: number;
    //钻石
    private m_diamonds : number;

    private m_normalCoins: number;
    private m_unlockLevel: number;
    //游戏初始时间
    private m_firstPlayerTime: number;
    //
    private readonly COINS_KEY: string = 'user-coins';
    private readonly DIAMONDS_KEY: string = 'user-diamonds';
    private readonly POWER_KEY: string = 'user-power';
    private readonly UNLOCK_KEY: string = 'user-unlock';
    private readonly POWER_TIME_KEY: string = 'user-power-time';
    private readonly FIRST_PLAY_KEY: string = 'user-first-play';
    static readonly GET_ZODIAC_KEY: string = 'user-get-zodiac';
    private readonly STRONGER_KEY: string = 'user-stronger';
    private readonly MOOD_KEY: string = 'user-mood';
    private readonly HEALTH_KEY: string = 'user-health';
    private readonly GAME_LOSE: string = 'game-lose';

    private readonly COIN_MAX_KEY :string = "user-max-coin-key";


    lastOpenTime:number = 0;

    //解锁 生肖数据
    static mZodiacData : string = null;
    //体力
    private mStronger : number = 100;
    //心情
    private mMood : number = 100;
    //健康
    private mHealth : number = 100;
    //游戏失败
    private mGameLose : number = 0;

    reset(){
        this.setCoins( gameConfig.NORMAL_COINS , false );
        this.setStronger( 100 , false );
        this.setMood( 80 , false );
        this.setHealth( 80 , false );
        this.setGameFail( 0 );
    }

    //游戏是否失败
    setGameFail( gameFail : number) {
        this.mGameLose = gameFail;
        O1HD.getServices().localStorageSrv.setStorage(this.GAME_LOSE, this.mGameLose );
    }
    getGameFail() {
        return this.mGameLose;
    }
    loadGameFail(){
        let data = O1HD.getServices().localStorageSrv.getStorage(this.GAME_LOSE);
        if (data == null || data === '') {
            this.mGameLose = 0;
        } else {
            this.mGameLose = Number(data);
        }
    }

    //体力值
    setStronger( stronger : number, isPlus : boolean) {
        if ( isPlus ) {
            O1HD.emit("ValueNode.changeValue" , "tili" , stronger );
            stronger = this.mStronger + stronger;
        }
        this.mStronger = data_control.getValueOfAreaMinMax( stronger, 0, 100 );
        O1HD.getServices().localStorageSrv.setStorage(this.STRONGER_KEY, this.mStronger );
    }
    getStronger() {
        return this.mStronger;
    }
    loadStronger(){
        let data = O1HD.getServices().localStorageSrv.getStorage(this.STRONGER_KEY);
        if (data == null || data === '') {
            this.mStronger = 0;
        } else {
            this.mStronger = Number(data);
        }
    }
    //心情
    setMood( mood : number, isPlus : boolean) {
        if ( isPlus ) {
            O1HD.emit("ValueNode.changeValue" , "xinqing" , mood );
            mood = Number( ( this.mMood + mood).toFixed());
        }
        this.mMood = data_control.getValueOfAreaMinMax( mood , 0, 100 );
        O1HD.getServices().localStorageSrv.setStorage(this.MOOD_KEY, this.mMood );
    }
    getMood() {
        return this.mMood;
    }
    loadMood(){
        let data = O1HD.getServices().localStorageSrv.getStorage(this.MOOD_KEY);
        if (data == null || data === '') {
            this.mMood = 0;
        } else {
            this.mMood = Number(data);
        }
    }
    //健康
    setHealth( health : number, isPlus : boolean) {
        if ( isPlus ) {
            O1HD.emit("ValueNode.changeValue" , "jiankang" , health );
            health = Number( ( this.mHealth + health ).toFixed());
        }
        this.mHealth = data_control.getValueOfAreaMinMax( health , 0, 100 );
        O1HD.getServices().localStorageSrv.setStorage( this.HEALTH_KEY , this.mHealth );
    }
    getHealth() {
        return this.mHealth;
    }
    loadHealth(){
        let data = O1HD.getServices().localStorageSrv.getStorage( this.HEALTH_KEY );
        if (data == null || data === '') {
            this.mHealth = 0;
        } else {
            this.mHealth = Number(data);
        }
    }

    //
    m_currLoginCode: string = null;
    //
    m_UniqueId: string = null;
    //
    private m_curWebUserInfo: WEB_USER_INFO = null;

    constructor() {
        super();
    }

    async loadService(): Promise<void> {
        await super.loadService();
        this.lastOpenTime = Date.now();
        this.onInitNormalData(
            gameConfig.MAX_POWER,
            gameConfig.NORMAL_POWER,
            gameConfig.NORMAL_COINS,
            gameConfig.NORMAL_DIAMONDS,
            gameConfig.ADD_ONCE_POWER,
            gameConfig.REST_POWER_TIME,
            gameConfig.REST_POWER_VALUE,
            gameConfig.ADD_ONCE_COINS,
            gameConfig.ADD_ONCE_DIAMONDS);
        //
        // this.onWebInfoUpdate();
        return Promise.resolve();
    }

    /**
     * 是否在新手保护的时间内
     * @returns
     */
    isFirstPlayerTimeIn() {
        return (Date.now() - this.m_firstPlayerTime) < (gameConfig.FIRST_VIDEO_TIME * 1000);
    }

    onInitNormalData(maxPower: number,
                     normalPower: number,
                     normalCoins: number,
                     normalDiamonds : number,
                     addOncePower: number,
                     restPowerTime: number,
                     restPowerValue: number,
                     addOnceCoins: number,
                     addOnceDiamonds : number ) {
        this.m_powerMax = maxPower;
        this.m_normalPower = normalPower;
        this.m_normalCoins = normalCoins;
        this.m_normalDiamond = normalDiamonds;
        this.m_constAddOncePower = addOncePower;
        this.m_constResetPowerTime = restPowerTime;
        this.m_constResetPowerValue = restPowerValue;
        this.m_constAddOnceCoins = addOnceCoins;
        this.m_constAddOnceDiamonds = addOnceDiamonds;
        //
        this.loadUserData();
    }

    getResetPowerTime() {
        return this.m_constResetPowerTime;
    }

    getResetPowerValue() {
        return this.m_constResetPowerValue;
    }

    setCoins( 
        coins: number
        , isPlus: boolean
        , node:cc.Node = null
        , tNodePos: cc.Vec2 = null
        , coinParent: cc.Node = null
        , bShow: boolean = true
    ) {
        coins = Number(coins);
        if (isNaN(coins)) {
            console.error(`金币数据错误`);
            return;
        }
        if (isPlus) {
            if (bShow) {
                O1HD.emit("changeMoney" , coins );
            }
            if(node && coins > 0){
                O1HD.getManagers().gameMgr.ChaoPiaoAni(
                    node
                    , tNodePos || O1HD.getManagers().gameMgr.chaoPiaoInitPos
                    , coinParent
                );
            }
            coins = this.m_coins + coins;
        }
        if (bShow) {
            this.m_coins = data_control.getValueOfAreaMinMax(coins, 0, Number.MAX_VALUE);
            this.writeCoins();
        } else {
            this.writeCoins(coins, true);
        }
        
        this.setMaxCoin(this.m_coins);
    }

    getCoins() {
        return this.m_coins;
    }

    private writeDiamonds() {
        //
        O1HD.getServices().localStorageSrv.setStorage(this.DIAMONDS_KEY, this.m_diamonds);
    }
    setDiamonds( diamonds: number, isPlus: boolean ){
        if (isPlus) {
            diamonds = this.m_diamonds + diamonds;
        }
        this.m_diamonds = data_control.getValueOfAreaMinMax( diamonds, 0, Number.MAX_VALUE);
        this.writeDiamonds();
    }
    getDiamonds() {
        return this.m_diamonds;
    }


    setPower(power: number, isPlus: boolean, isCanBeyond?: boolean, isReset: boolean = false) {
        if (isPlus) {
            power = this.m_power + power;
        }
        //满的开始扣
        if (this.m_powerMax == this.m_power && power == this.m_power - 1) {
            isReset = true;
        }
        if (isCanBeyond) {
            this.m_power = data_control.getValueOfAreaMinMax(power, 0, 9999);
        } else {
            // if (this.m_power < this.m_powerMax) {
            this.m_power = data_control.getValueOfAreaMinMax(power, 0, this.m_powerMax);
            // }
        }
        this.writePower(isReset);
    }


    getMaxPower() {
        return this.m_powerMax;
    }

    getNormalPower() {
        return this.m_normalPower;
    }

    getPower() {
        return this.m_power;
    }

    getMemberStatus() {
        let ms = O1HD.getServices().localStorageSrv.getStorage('private-member-type') || '0';
        return Number(ms);
    }

    setMemberStatus(type: number = 0) {
        O1HD.getServices().localStorageSrv.setStorage('private-member-type', type);
        O1HD.getServices().localStorageSrv.setStorage('user-membertime', Date.now());
    }

    //看广告添加体力
    addPowerOfVideo() {//
        this.setPower(this.m_constAddOncePower, true, true);
    }
    //
    addDiamondOfVideo() {//
        this.setDiamonds(this.m_constAddOnceDiamonds, true );
    }

    getConstAddOncePower() {
        return this.m_constAddOncePower;
    }

    setUnlockLevel(unlockLevel: number, isPlus: boolean) {
        if (isPlus) {
            unlockLevel = this.m_unlockLevel + unlockLevel;
        }
        this.m_unlockLevel = unlockLevel;
        this.writeUnLockLevel();
    }

    getUnlockLevel() {
        return this.m_unlockLevel;
    }

    //回复体力倒计时
    getPowerResetTimer(): number {
        let dateNow = Date.now();
        let dateOld = O1HD.getServices().localStorageSrv.getStorage(this.POWER_TIME_KEY) || dateNow;
        return this.m_constResetPowerTime - Math.floor((dateNow - Number(dateOld)) / 1e3);
    }

    onPowerTimerReset(): boolean {
        //计算体力恢复
        let dateNow = Date.now();
        let dateOld = O1HD.getServices().localStorageSrv.getStorage(this.POWER_TIME_KEY) || dateNow;
        dateOld = Number(dateOld);
        let restCount = Math.floor((dateNow - dateOld) / (this.m_constResetPowerTime * 1000));
        //
        let addHp = restCount * this.m_constResetPowerValue;
        if (addHp && this.getPower() < this.m_powerMax) {
            this.setPower(addHp, true, false, true);
            return true;
        }
        return false;
    }

    loadUser() {
        //
        this.loadNameAndHead();
    }

    // //用户http通信的account
    // private m_playerHttpAccount: string;
    // private readonly PLAYER_HTTP_ACCOUNT: string = 'player-http-account';
    // getPlayerHttpAccountNoHttp() {
    //     return this.m_playerHttpAccount;
    // }

    // getPlayerHttpAccount(code: string, anonymousCode: string, ttUserName: string, ttIcon: string, ttProvince: string, clickId?: string) {
    //     this.m_playerHttpAccount = O1HD.getServices().localStorageSrv.getStorage(this.PLAYER_HTTP_ACCOUNT, true);
    //     let params: AqLoginBody = {
    //         platform: `${Platform.H5}`
    //     };
    //     let userparams: AqUserLoginBody = {
    //         platform: `${Platform.H5}`
    //     };

    //     if (this.m_playerHttpAccount && this.m_playerHttpAccount.length > 0) {
    //         params.account = this.m_playerHttpAccount;
    //         userparams.account = this.m_playerHttpAccount;
    //     }
    //     switch (cc.sys.platform) {
    //         case cc.sys.BYTEDANCE_GAME:
    //         case cc.sys.BYTEDANCE_GAME_SUB: {
    //             params.platform = `${Platform.TT}`;
    //             params.code = code;
    //             params.anonymousCode = anonymousCode;
    //             params.nickName = ttUserName;
    //             params.headData = ttIcon;
    //             params.province = ttProvince;
    //             params.clickId = clickId;


    //             userparams.platform = `${Platform.TT}`;
    //             userparams.code = code;
    //             userparams.anonymousCode = anonymousCode;
    //             userparams.nickName = ttUserName;
    //             userparams.headData = ttIcon;
    //             userparams.gameId = "tt324344fead7f03ff02";
    //             userparams.secretId = "c22524e017724273df2fa451451e39a7391cb6de"
    //             userparams.clickId = clickId;
    //             break;
    //         }
    //     }
    //     // console.error("排行榜登录请求发送")
    //     // modules().gameHttpModule.sendMessage(AqLoginMsg.head, "POST", params, (res: AqLoginRes) => {
    //     //     console.log("排行榜登录成功", res)
    //     //     this.m_playerHttpAccount = res.account;
    //     //     // this.province = res.province;
    //     //     // this.city = res.city
    //     //     this.writePlayerHttpAccount();
    //     // });
    //     console.error("ecpm登录请求发送")
    //     modules().gameHttpModule.sendMessage(AqUserLoginMsg.head, "POST", userparams, (res: AqUserLoginRes) => {
    //         console.log("ecpm登录成功", res)
    //         this.m_playerHttpAccount = res.account;
    //         // this.province = res.province;
    //         // this.city = res.city
    //         this.writePlayerHttpAccount();
    //     });

    // }

    // writePlayerHttpAccount() {
    //     O1HD.getServices().localStorageSrv.setStorage(this.PLAYER_HTTP_ACCOUNT, this.m_playerHttpAccount, true);
    // }

    
  //#region 
  //用户http通信的account
  private m_playerHttpAccount: string;
  private readonly PLAYER_HTTP_ACCOUNT: string = 'player-http-account-wwmxd';
  getPlayerHttpAccountNoHttp() {
    return this.m_playerHttpAccount;
  }


  getPlayerHttpAccount(code: string, anonymousCode: string, ttUserName: string, ttIcon: string, ttProvince: string, clickId?: string) {
    this.m_playerHttpAccount = O1HD.getServices().localStorageSrv.getStorage(this.PLAYER_HTTP_ACCOUNT, true);
    let params: AqUserLoginBody = {
      platform: `${Platform.H5}`
    };
    if (this.m_playerHttpAccount && this.m_playerHttpAccount.length > 0) {
      params.account = this.m_playerHttpAccount;
    }
    switch (cc.sys.platform) {
      case cc.sys.BYTEDANCE_GAME:
      case cc.sys.BYTEDANCE_GAME_SUB: {
        let sv = <TtApi>services().miniGameSrv.getAppApiInstance();
        params.platform = `${Platform.TT}`;
        params.code = code;
        params.anonymousCode = anonymousCode;
        params.nickName = ttUserName;
        params.headData = ttIcon;
        params.gameId = sv.getAppid();
        params.secretId = sv.getSecretid();
        params.clickId = clickId;
        break;
      }
    }
    console.log("登录成功发送申请")
    modules().gameHttpModule.sendMessage(AqLoginMsg.head, "POST", params, (res: AqUserLoginRes) => {
      console.log("返回成功",res)
      this.m_playerHttpAccount = res.account;
      this.writePlayerHttpAccount();
    });
  }
  writePlayerHttpAccount() {
    O1HD.getServices().localStorageSrv.setStorage(this.PLAYER_HTTP_ACCOUNT, this.m_playerHttpAccount, true);
  }
  //#endregion
    private loadFirstPlayerTime() {
        this.m_firstPlayerTime = Number(O1HD.getServices().localStorageSrv.getStorage(this.FIRST_PLAY_KEY) || '0');
        if (this.m_firstPlayerTime == 0) {
            this.m_firstPlayerTime = Date.now();
            this.writeFirstPlayerTime();
        }
    }

    private writeFirstPlayerTime() {
        O1HD.getServices().localStorageSrv.setStorage(this.FIRST_PLAY_KEY, this.m_firstPlayerTime);
    }

    private loadUserData() {
        this.loadCoins();
        this.loadPower();
        this.loadDiamond();
        this.loadUnlockLevel();
        this.loadFirstPlayerTime();
        //
        this.loadNameAndHead();
        //自定义 数据
        this.loadStronger();
        this.loadMood();
        this.loadHealth();
        this.loadGameFail();
        this.loadMaxCoin();
    }

    private m_MaxCoin:number = 0;

    loadMaxCoin(){
        let max = O1HD.getServices().localStorageSrv.getStorage(this.COIN_MAX_KEY) || "0";
        let m = Number(max);
        if(isNaN(m)){
            m = 0;
        }
        this.m_MaxCoin = m;
    }

    setMaxCoin(max:number){
        // if(max > this.m_MaxCoin){
        //     this.m_MaxCoin = max;
        //     this.writeCoins();
            O1HD.getServices().miniGameSrv.getAppApiInstance().commitRank(max);
        // }
    }

    getMaxCoin(){
        return this.m_MaxCoin;
    }

    writeMaxCoin(){
        O1HD.getServices().localStorageSrv.setStorage(this.COIN_MAX_KEY,this.m_MaxCoin);
    }

    private loadUnlockLevel() {
        this.m_unlockLevel = Number(O1HD.getServices().localStorageSrv.getStorage(this.UNLOCK_KEY) || 0);
    }

    private writeUnLockLevel() {
        O1HD.getServices().localStorageSrv.setStorage(this.UNLOCK_KEY, this.m_unlockLevel);
    }

    private loadCoins() {
        let data = O1HD.getServices().localStorageSrv.getStorage(this.COINS_KEY);
        if (data == null || data === '') {
            this.m_coins = this.m_normalCoins;
        } else {
            this.m_coins = Number(data);
        }
    }

    private loadPower() {
        const powerStr = O1HD.getServices().localStorageSrv.getStorage(this.POWER_KEY);
        if (powerStr === '' || powerStr === null) this.m_power = this.m_normalPower;
        else this.m_power = Number(powerStr);
        //体力恢复
        this.onPowerTimerReset();
    }

    private loadDiamond(){
        const diamondStr = O1HD.getServices().localStorageSrv.getStorage( this.DIAMONDS_KEY );
        if ( diamondStr === '' || diamondStr === null ) {
            this.m_diamonds = this.m_normalDiamond;
        }else{
            this.m_diamonds = Number( diamondStr );
        }
    }

    private writeCoins(coin: number = 0, bUseParam: boolean = false) {
        //
        let gCoin = this.m_coins;
        if (bUseParam) {
            gCoin = coin;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.COINS_KEY, gCoin);
    }

    private writePower(isReset: boolean) {
        //
        O1HD.getServices().localStorageSrv.setStorage(this.POWER_KEY, this.m_power);
        let nil = services().localStorageSrv.getStorage(this.POWER_TIME_KEY);
        if (isReset || !nil) {
            let dateNow = Date.now();
            O1HD.getServices().localStorageSrv.setStorage(this.POWER_TIME_KEY, dateNow);
        }
    }

    private loadNameAndHead() {
        //
        // return;
        //
        let currMiniApp = O1HD.getServices().miniGameSrv.getAppApiInstance();
        //
        let fail = () => {
            currMiniApp.showToast({title: '登录失败'});
        };
        //已登录
        // if (this.m_currLoginCode) return;
        //登录
        currMiniApp.login({
            force: false,
            success: (res) => {
                // this.m_currLoginCode = res.code;
                //授权
                currMiniApp.authorize({
                    success: () => {
                        //信息获取
                        currMiniApp.getUserInfo({
                            success: (res) => {
                                // this.m_name = res.userInfo.nickName;
                                // this.m_headImage = res.userInfo.avatarUrl;
                            },
                            fail,
                        });
                    },
                    fail,
                })
                // //获取唯一ID
                // if (this.m_UniqueId) {
                //     return;
                // }
                // //
                // gameHttp_module.getUserWxIdentifyByCode(this.m_currLoginCode, (res) => {
                //     console.debug('我的唯一ID', res);
                //     this.m_UniqueId = res;
                //     gameHttp_module.getUserWebInfo(this.m_UniqueId, (res) => {
                //         this.m_curWebUserInfo = JSON.parse(res);
                //         console.debug('读取到的数据', res);
                //         this.onWebInfoGetOnce();
                //     }, res1 => {
                //         this.m_curWebUserInfo = {
                //             m_coins: this.m_normalCoins,
                //             m_devilCurrLevel: 0,
                //             m_synthesisEquipmentList: [],
                //             m_unlockStamp: 0,
                //         }
                //     });
                // })
            },
            fail,
        });
    }

    private onWebInfoUpdate() {
        setInterval(() => {
            if (this.m_UniqueId == null || this.m_curWebUserInfo == null) return;
            for (let key in this.m_curWebUserInfo) {
                this.m_curWebUserInfo[key] = this[key];
            }
            console.log('更新数据', this.m_UniqueId, this.m_curWebUserInfo);
        }, 3e3);
    }

    private onWebInfoGetOnce() {
        //没有线上
        if (this.m_UniqueId == null || this.m_curWebUserInfo == null) return;
        //如果经验金币都有，就说明读到了
        if (this.m_coins != this.m_normalCoins) return;
        console.log('获取数据', this.m_curWebUserInfo);
        //
        for (let key in this.m_curWebUserInfo) {
            this[key] = this.m_curWebUserInfo[key];
        }
    }

}























